import { render, staticRenderFns } from "./RoleChange.vue?vue&type=template&id=8d5f0da8&scoped=true"
import script from "./RoleChange.vue?vue&type=script&lang=ts"
export * from "./RoleChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5f0da8",
  null
  
)

export default component.exports